import { useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useEndpointHook } from "../../../hooks/useEndpointHook";
import { financingRequestsClear } from "../../../redux/reducers/financingRequestsReducer";
import FileUploadModal from "./FileUploadModal";

const UploadLoanFileModal = ({
  show,
  dealId,

  title,
  onClose,
  docType,
  docGroup,
  onSuccessFn,
}) => {
  const theme = useTheme();

  const { uploadFilesToLoan, loading } = useEndpointHook();
  const dispatch = useDispatch();

  const handleOnSubmit = (files) => {
    uploadFilesToLoan({
      dealId: dealId,
      files,
      onSuccessFn: () => {
        if (onClose) {
          onClose(false);
        }
        if (onSuccessFn) {
          onSuccessFn();
        }
        dispatch(financingRequestsClear());
      },
    });
  };

  return (
    <FileUploadModal
      docGroup={docGroup}
      docType={docType}
      // show={showModal}
      title={title}
      // files={files}
      show={show}
      onClose={onClose}
      description={`Upload documents for your financing request.`}
      // docGroup={docGroup}
      // docType={docType}
      onSubmit={handleOnSubmit}
      key={`${docGroup}-${docType}-upload-modal-upload`}
      loading={loading}
      // onSubmit={onSubmit}
    />
  );

  // return (
  //   <BasicModal
  //     show={show}
  //     disableAutoMobile
  //     title={title || "Upload Files"}
  //     maxWidth="sm"
  //     bodySx={{ p: 2 }}
  //     icon={isMobile ? null : <FileUploadOutlined />}
  //     allowFullScreen
  //     onClose={onClear}
  //   >
  //     <UploadFileContent
  //       docType={docType}
  //       altLoading={loading}
  //       docGroup={docGroup}
  //       onUploadSuccess={(d, uploadedDocuments) => {
  //         if (onFileUploadSuccess) {
  //           onFileUploadSuccess(d, uploadedDocuments);
  //           return;
  //         }
  //         onClear();
  //       }}
  //     />
  //   </BasicModal>
  // );
};

// const UploadFileContent = ({
//   docType,
//   docGroup,
//   onUploadSuccess,
//   altLoading,
// }) => {
//   const { uploadFilesToLoan, loading } = useEndpointHook();
//   const [files, setFiles] = useState(null);

//   const updateFilesMetadata = (files, docGroup, docType) => {
//     // Guard clause for empty files array
//     if (!files || files.length === 0) {
//       return [];
//     }

//     // Create a new array with updated metadata
//     return files.map((file) => {
//       // Create a copy of the file to avoid mutating the original
//       const updatedFile = { ...file };

//       // Update docGroup if provided
//       if (docGroup !== undefined && docGroup !== null) {
//         updatedFile.docGroup = docGroup;

//         // Clear docType if docGroup changes and the types don't match
//         // This assumes docType is dependent on docGroup
//         if (updatedFile.docType && docType === undefined) {
//           updatedFile.docType = undefined;
//         }
//       }

//       // Update docType if provided
//       if (docType !== undefined && docType !== null) {
//         updatedFile.docType = docType;
//       }

//       return updatedFile;
//     });
//   };

//   const onFilesAdded = useCallback(
//     (newFiles, docGroup, docType) => {
//       let updatedFiles = updateFilesMetadata(newFiles, docGroup, docType);
//       if (isEmpty(files)) {
//         setFiles(updatedFiles);
//         return;
//       }

//       setFiles([...files, ...updatedFiles]);
//     },
//     [files],
//   );

//   const handleUploadFiles = useCallback(() => {
//     uploadFilesToLoan({
//       dealId: dealId,
//       files,
//       onSuccessFn: () => {
//         handleOnClose();
//         dispatch(financingRequestsClear());
//       },
//     });
//   }, [files, onUploadSuccess]);

//   return (
//     <>
//       <FileUploadField
//         key={`${docType}-initial-upload`}
//         id={`${docType}-initial-file-upload`}
//         suppressUploadButton
//         borderSize={1.5}
//         docGroup={docGroup}
//         docType={docType}
//         hideFileList
//         onFilesAdded={onFilesAdded}
//       />
//       <UploadedFilesTable files={files} setFiles={setFiles} />
//       {isEmpty(files) ? null : (
//         <Flx
//           g={1}
//           fw
//           ac
//           end
//           wrap
//           sx={{
//             mt: 4,
//           }}
//         >
//           <Button
//             onClick={() => setFiles(null)}
//             variant="outlined"
//             size="large"
//             color="primary"
//           >
//             Cancel
//           </Button>

//           <Button
//             // loading={altLoading || loading}
//             loading={loading}
//             onClick={handleUploadFiles}
//             startIcon={
//               <FileUploadRounded
//                 className="thin"
//                 sx={{ fontSize: "16px !important" }}
//               />
//             }
//             size="large"
//             color="primary"
//           >
//             Upload Files ({size(files)})
//           </Button>
//         </Flx>
//       )}
//     </>
//   );
// };

// const UploadedFilesTable = ({ files, setFiles }) => {
//   const ref = useRef();

//   const modalContentRef = useRef(null);

//   const columnDefs = useMemo(
//     () => [
//       {
//         headerName: "Filename",
//         field: "file_display_name",
//         flex: 1,
//         minWidth: 220,
//         cellEditor: "agTextCellEditor",
//         editable: true,
//         // checkbox: true,
//         cellStyle: {
//           display: "flex",
//           alignItems: "center",
//           gap: "6px",
//           paddingLeft: "6px",
//         },
//         cellRenderer: (params) => {
//           // console.log("params", params);
//           return (
//             <>
//               <AttachFileOutlined
//                 className="thin"
//                 sx={{ fontSize: 16 }}
//                 // contentType={params?.value?.content_type}
//               />
//               {/* <FilePreviewImageTypeIcon
//                 size={18}
//                 contentType={params?.value?.content_type}
//               /> */}
//               {params.value}
//             </>
//           );
//         },
//       },
//       // {
//       //   headerName: "Document Group",
//       //   field: "docGroup",
//       //   editable: true,
//       //   width: 220,
//       //   cellEditor: "agRichSelectCellEditor",
//       //   cellEditorPopup: true,
//       //   cellEditorParams: {
//       //     values: fileDocGroups || [],
//       //   },
//       // },
//       // {
//       //   headerName: "Document Type",
//       //   field: "docType",
//       //   editable: true,
//       //   width: 220,
//       //   cellEditor: "agRichSelectCellEditor",
//       //   cellEditorPopup: true,
//       //   cellEditorParams: (params) => {
//       //     return {
//       //       values: getDocTypesByGroup(params.data.docGroup || "Appraisal"),
//       //     };
//       //   },
//       // },
//       {
//         width: 36,
//         pinned: "right",
//         cellStyle: {
//           paddingRight: 0,
//           paddingLeft: 0,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         },
//         field: "delete",
//         cellRenderer: (params) => {
//           return (
//             <IconButton sx={{ p: 0.4 }} size="small">
//               <CloseRounded className="thin" />
//             </IconButton>
//           );
//         },
//       },
//     ],
//     [],
//   );

//   const handleCellValueChanged = useCallback(
//     (params) => {
//       const { colDef, data, newValue } = params;

//       // Create a copy of the data to update
//       const updatedData = { ...data };

//       // If the user changes the filename
//       if (colDef.field === "file_display_name") {
//         const originalExtension = data.name.split(".").pop().toLowerCase();
//         const newValueWithoutExt = newValue.replace(/\.[^/.]+$/, "");
//         updatedData.file_display_name = `${newValueWithoutExt}.${originalExtension}`;
//       }

//       // If the user changes docGroup
//       if (colDef.field === "docGroup") {
//         updatedData.docGroup = newValue;
//         // Clear docType when docGroup changes
//         updatedData.docType = "";
//       }

//       // If the user changes docType
//       if (colDef.field === "docType") {
//         updatedData.docType = newValue;
//       }

//       // Update the parent files state
//       setFiles((prev) =>
//         prev.map((item) => (item.id === data.id ? updatedData : item)),
//       );

//       setTimeout(() => {
//         if (ref.current && ref.current.api) {
//           ref.current.api.refreshCells();
//         }
//       }, 0);
//     },
//     [setFiles],
//   );

//   const onCellClicked = useCallback(
//     (params) => {
//       const { colDef, data } = params;

//       if (colDef.field === "delete") {
//         setFiles((prev) => prev.filter((item) => item.id !== data.id));
//       }
//     },
//     [setFiles],
//   );

//   const columnTypes = useMemo(() => {
//     return {
//       ...columnTypesDate(),
//       ...columnTypesNumber(),
//     };
//   }, []);

//   if (isEmpty(files)) {
//     return null;
//   }

//   return (
//     <Box
//       sx={{
//         maxHeight: "200px",
//         overflowY: "auto",
//         // mt: -0.4,
//         border: (theme) => `1px solid ${theme.palette.divider}`,
//         borderRadius: 0,
//         borderBottomRightRadius: "8px",
//         borderBottomLeftRadius: "8px",
//         // mt: -0.5,
//         ".ag-row-last": {
//           borderBottom: "none !important",
//         },
//       }}
//     >
//       <AgGridTableWrapper simpleTable suppressMinHeightWhenPopulated={files}>
//         <AgGridReact
//           ref={ref}
//           rowData={files}
//           columnDefs={columnDefs}
//           singleClickEdit
//           onCellClicked={onCellClicked}
//           columnTypes={columnTypes}
//           domLayout={"autoHeight"}
//           headerHeight={0}
//           onCellValueChanged={handleCellValueChanged}
//           stopEditingWhenCellsLoseFocus
//           popupParent={modalContentRef.current}
//           // getRowId={(params) => params.data.id}
//           // onSelectionChanged={handleRowSelectionChange}
//           // rowSelection={{
//           //   mode: "multiRow",
//           // }}
//         />
//       </AgGridTableWrapper>
//     </Box>
//   );
// };

export default UploadLoanFileModal;
